import React, { useEffect, useState } from 'react';
import HelpIcon from '@material-ui/icons/Help';
import { Tooltip, IconButton } from '@material-ui/core';

import { Title, Text } from 'components/Text';
import { Button } from 'components/Button';

import { getCustomers, updateCustomer } from 'services/api/customers';

import { useHistory } from 'react-router-dom';

import PATH from 'routes/path';

import { Container, Header, BoxText } from 'pages/Documents/styles';

import HelpModal from './HelpModal';

const Atermacao = () => {
  const [openHelp, setOpenHelp] = useState(false);

  const history = useHistory();

  const showHelp = () => {
    window.Intercom('trackEvent', 'LOIT FGTS documentos ajuda');
    setOpenHelp(true);
  };

  const handleUpdateStep = async () => {
    const customer = await getCustomers();
    const payload = {
      ...customer.data[0],
      meta_data: {
        ...customer.data[0].meta_data,
        step: customer.data[0].meta_data.step && customer.data[0].meta_data.step > 4 ? customer.data[0].meta_data.step : 4,
      },
    };
    await updateCustomer(customer.data[0].id, payload);
  };

  const closeHelp = () => setOpenHelp(false);

  useEffect(() => {
    document.title = 'Atermação - Revisão FGTS - LOIT';

    // Evento do Intercom para Atermação
    window.Intercom('trackEvent', 'LOIT FGTS atermacao');

    handleUpdateStep();
  }, []);

  return (
    <Container>
      <Header>
        <Title secondary>Atermação</Title>
        {/* ICONE DE AJUDA */}
        <Tooltip title="Informação sobre documentos requisitados" arrow>
          <IconButton
            size="small"
            onClick={showHelp}
            disabled={openHelp}
            color="secondary"
          >
            Ajuda
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </Header>
      {/* MODAL DE AJUDA */}
      {
        openHelp && (
          <HelpModal
            open={openHelp}
            onClose={closeHelp}
          />
        )
      }
      <BoxText>
        <Text>Parabéns!</Text>
      </BoxText>
      <BoxText>
        <Text>Agora, nossa equipe fará o processo de atermação do seu pedido junto ao Juizado Especial Federal.</Text>
      </BoxText>
      <BoxText>
        <Text>Você receberá em até 1 hora um e-mail com todos os detalhes do serviço e sobre os próximos passos.</Text>
      </BoxText>
      <BoxText>
        <Text>Neste momento não é necessária nenhuma ação de sua parte, apenas aguardar e responder a mensagem que chegará em seu e-mail.</Text>
      </BoxText>
      <BoxText>
        <Text>
          Caso tenha dúvidas, você sempre pode consultar nossa
          {' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://ajuda.tikal.tech/pt-BR/collections/2748191-loit-fgts-revisao-do-fgts-para-o-cidadao"
          >
            Central de Ajuda.
          </a>
        </Text>
      </BoxText>
      <BoxText>
        <Text>Se precisar falar conosco você pode utilizar o ícone de ajuda nessa página.</Text>
      </BoxText>
      <Button
        onClick={() => history.push(PATH.HOME)}
        variant="outlined"
        className="unset"
      >
        Voltar
      </Button>
    </Container>
  );
};

export default Atermacao;
